<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

/**
 * System Messages Page
 */
export default {
  page() {
    return {
      title: this.title,
      meta: [{ name: "description" }],
    };
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Messages",
      items: [],
      loading: false,
      messagelist: [],
      currentPage: 1,
      userinfo: null,
      pagesize: 20,
      totalCount: 0,
    };
  },
  mounted() {
    this.title = this.$t("navbar.dropdown.notification.text");
    this.items = [
      {
        text: this.$t("dashboard.text"),
        href: "/",
      },
      {
        text: this.$t("navbar.dropdown.notification.text"),
        active: true,
      },
    ];

    try {
      this.userinfo = JSON.parse(localStorage.getItem("user"));
      if (!this.userinfo) {
        this.$message.error(this.$t("global.errors.loginrequired"));
        this.$router.push({ name: "login" });
        return;
      }
    } catch (error) {
      console.error("解析用户信息失败:", error);
      this.$message.error(this.$t("global.errors.loginrequired"));
      this.$router.push({ name: "login" });
      return;
    }

    this.getmessagelist();
  },
  methods: {
    getmessagelist() {
      this.loading = true;
      this.$axios
        .post(
          this.apiuri,
          {
            action: "getnotifymessage",
            page: this.currentPage,
            limit: this.pagesize,
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          this.loading = false;
          if (response.data.status === 200 || response.data.list) {
            this.messagelist = response.data.list || [];
            this.totalCount = parseInt(response.data.count) || 0;
          } else {
            this.$message.error(response.data.msg || response.data.message || this.$t("global.errors.loaddata"));
            this.messagelist = [];
            this.totalCount = 0;
          }
        })
        .catch((error) => {
          this.loading = false;
          console.error("获取消息列表失败:", error);
          this.$message.error(this.$t("global.errors.network"));
          this.messagelist = [];
          this.totalCount = 0;
        });
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.currentPage = 1;
      this.getmessagelist();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getmessagelist();
    },
    refresh() {
      this.currentPage = 1;
      this.getmessagelist();
    },
    // 将任意值安全转为可展示字符串，避免出现 [object Object]
    formatValue(val) {
      if (val === undefined || val === null || val === '') {
        return '-';
      }
      if (typeof val === 'object') {
        try {
          return JSON.stringify(val);
        } catch (e) {
          return String(val);
        }
      }
      return String(val);
    },
    // 确保 i18n 返回值为字符串（命中嵌套对象时 vue-i18n 会返回 object）
    translateText(key, values) {
      const text = values !== undefined ? this.$t(key, values) : this.$t(key);
      if (typeof text === 'string') {
        return text;
      }
      if (text && typeof text === 'object') {
        return key;
      }
      return this.formatValue(text);
    },
    parseMessageData(raw) {
      if (!raw) {
        return null;
      }
      if (typeof raw === 'string') {
        try {
          return JSON.parse(raw);
        } catch (e) {
          return raw;
        }
      }
      return raw;
    },
    formatMessage(row) {
      if (!row.data) {
        return '-';
      }

      const data = this.parseMessageData(row.data);
      if (typeof data === 'string') {
        return data;
      }
      if (!data || typeof data !== 'object') {
        return this.formatValue(data);
      }

      // 格式1: 外部 API 请求（有 post 和 receive 字段）
      if (data.post !== undefined || data.receive !== undefined) {
        const parts = [];
        const requestLabel = this.translateText('system.message.api.request') || '请求';
        const responseLabel = this.translateText('system.message.api.response') || '响应';

        // 处理请求数据 (post)
        if (data.post) {
          let postText = '';
          if (typeof data.post === 'object') {
            const postParts = [];
            if (data.post.card !== undefined && data.post.card !== null) {
              postParts.push(`${this.translateText('system.message.api.card') || '卡号'}: ${this.formatValue(data.post.card)}`);
            }
            if (data.post.value !== undefined && data.post.value !== null) {
              postParts.push(`${this.translateText('system.message.api.value') || '值'}: ${this.formatValue(data.post.value)}`);
            }
            if (data.post.gid !== undefined && data.post.gid !== null) {
              postParts.push(`${this.translateText('system.message.api.groupid') || '组ID'}: ${this.formatValue(data.post.gid)}`);
            }
            const otherKeys = Object.keys(data.post).filter(key =>
              !['card', 'value', 'gid'].includes(key)
            );
            otherKeys.forEach(key => {
              if (data.post[key] !== undefined && data.post[key] !== null) {
                postParts.push(`${key}: ${this.formatValue(data.post[key])}`);
              }
            });
            postText = postParts.length > 0
              ? `${requestLabel}: ${postParts.join(', ')}`
              : `${requestLabel}: ${this.formatValue(data.post)}`;
          } else {
            postText = `${requestLabel}: ${this.formatValue(data.post)}`;
          }
          parts.push(postText);
        }

        // 处理响应数据 (receive)
        if (data.receive !== undefined && data.receive !== null) {
          if (typeof data.receive === 'object' && Object.keys(data.receive).length === 0) {
            parts.push(`${responseLabel}: ${this.translateText('system.message.api.empty') || '空'}`);
          } else {
            parts.push(`${responseLabel}: ${this.formatValue(data.receive)}`);
          }
        } else if (data.post) {
          parts.push(`${responseLabel}: ${this.translateText('system.message.api.pending') || '等待中'}`);
        }

        return parts.length > 0
          ? parts.join(' | ')
          : (this.translateText('system.message.api.external') || '外部 API 请求');
      }

      // 格式2: 有 Action 或 action 字段，以及 type1, type2 等字段
      const hasAction = data.Action === 'notice' || data.action === 'notice' || data.Action || data.action;

      if (hasAction && data.type2) {
        const type2 = data.type2;
        const type1 = data.type1;
        const type1Text = type1 ? this.translateText('global.notice.' + type1) : '';

        if (type2 === 'device') {
          return this.translateText('global.notice.device', {
            device: this.formatValue(data.edid),
          }) + (type1Text ? ' ' + type1Text : '');
        }

        if (type2 === 'service') {
          const serviceName = data.service
            ? this.translateText('global.notice.server.' + data.service)
            : '-';
          return this.translateText('global.notice.service', {
            service: serviceName,
          }) + (type1Text ? ' ' + type1Text : '');
        }

        if (type2 === 'stock') {
          return this.translateText('global.notice.stock', {
            edid: this.formatValue(data.edid),
            stock: this.formatValue(data.stock),
          });
        }

        if (type2 === 'sensor') {
          return this.translateText('global.notice.sensor', {
            edid: this.formatValue(data.edid),
            num: this.formatValue(data.num),
          });
        }

        // 其他 type2 类型
        if (type1) {
          return type1Text && type1Text !== ('global.notice.' + type1)
            ? type1Text
            : `${type2}: ${type1}`;
        }

        return this.formatValue(type2);
      }

      // 兼容 title / message 字段
      if (data.title || data.message) {
        const title = data.title ? this.formatValue(data.title) : '';
        const message = data.message ? this.formatValue(data.message) : '';
        return [title, message].filter(Boolean).join(' - ') || '-';
      }

      if (data.topic) {
        return `主题: ${this.formatValue(data.topic)}`;
      }

      return this.formatValue(data);
    },
    getMessageTypeLabel(type) {
      if (!type) {
        return '-';
      }
      const label = this.translateText('global.notice.type.' + type);
      return label && label !== ('global.notice.type.' + type) ? label : String(type);
    },
    getTagType(type) {
      const typeMap = {
        'warning': 'warning',
        'error': 'danger',
        'success': 'success',
        'info': 'info',
      };
      return typeMap[type] || 'info';
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <el-card class="box-card" v-loading="loading">
          <div slot="header" class="clearfix">
            <span>
              <i class="el-icon-message"></i>
              {{ $t("navbar.dropdown.notification.text") }}
            </span>
            <div style="float: right;">
              <el-button
                icon="el-icon-refresh"
                @click="refresh"
                :loading="loading"
                circle
                size="small"
              ></el-button>
            </div>
          </div>
          <div class="row mb-3" v-if="totalCount > 0">
            <div class="col-md-6">
              <span class="text-muted">
                {{ $t('global.text.total') }}: <strong>{{ totalCount }}</strong>
              </span>
            </div>
          </div>
          <el-table 
            :data="messagelist" 
            style="width: 100%"
            stripe
            border
            :empty-text="$t('global.text.nodata') || '暂无数据'"
            show-overflow-tooltip
          >
            <el-table-column 
              prop="id" 
              :label="$t('system.message.index')" 
              width="80"
              align="center"
            >
            </el-table-column>
            <el-table-column 
              :label="$t('system.message.type')" 
              width="120"
              align="center"
            >
              <template slot-scope="scope">
                <el-tag 
                  :type="getTagType(scope.row.type)"
                  size="small"
                >
                  {{ getMessageTypeLabel(scope.row.type) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column 
              :label="$t('system.message.body')"
              min-width="300"
            >
              <template slot-scope="scope">
                <span>{{ formatMessage(scope.row) }}</span>
              </template>
            </el-table-column>
            <el-table-column 
              prop="time" 
              :label="$t('system.message.time')" 
              width="180"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.time || '-' }}</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="row mt-3" v-if="totalCount > 0">
            <div class="col-12">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pagesize"
                :current-page="currentPage"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
                class="text-right"
              >
              </el-pagination>
            </div>
          </div>
        </el-card>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.box-card {
  margin-bottom: 20px;
}

.clearfix {
  font-weight: 500;
}

.clearfix i {
  margin-right: 5px;
}
</style>